"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var owa_outlook_service_options_1 = require("owa-outlook-service-options");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SmartSuggestions);
    },
})(legacy_1.action('saveQuickSuggestionOption')(function saveQuickSuggestionOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.smartSuggestionsEnabled = owa_options_core_1.getFallbackValueIfNull(optionState.smartSuggestionsEnabled, userOptions.smartSuggestionsEnabled);
                    userOptions.browserLocationEnabled = owa_options_core_1.getFallbackValueIfNull(optionState.browserLocationEnabled, userOptions.browserLocationEnabled);
                    return [4 /*yield*/, owa_outlook_service_options_1.lazyCreateOrUpdateOptionsForFeature.importAndExecute(owa_outlook_service_options_1.OwsOptionsFeatureType.SmartSuggestions, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveQuickSuggestionOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-quick-suggestions-option/lib/actions/saveQuickSuggestionOption.js
// module id = 5136
// module chunks = 2